import { FC } from 'react'

interface LoadingSpinnerProps {
  message?: string
  /**
   * Fill the viewport. True by default because the first callers were whole
   * pages of their own (the magic-link sign-in, accepting an invite).
   *
   * Pass false inside the app shell: the 100vh is measured from below the
   * header, so it puts a scrollbar on a screen that is only waiting.
   */
  fullScreen?: boolean
}

const LoadingSpinner: FC<LoadingSpinnerProps> = ({
  message = 'Loading...',
  fullScreen = true,
}) => {
  return (
    <div className={`loading-spinner${fullScreen ? '' : ' is-contained'}`} role="status">
      <div className="spinner" aria-hidden="true"></div>
      <p>{message}</p>
    </div>
  )
}

export default LoadingSpinner
